var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1556_106956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66927 12.6654H5.33594C2.66927 12.6654 1.33594 11.9987 1.33594 8.66536V5.33203C1.33594 2.66536 2.66927 1.33203 5.33594 1.33203H10.6693C13.3359 1.33203 14.6693 2.66536 14.6693 5.33203V8.66536C14.6693 11.332 13.3359 12.6654 10.6693 12.6654H10.3359C10.1293 12.6654 9.92927 12.7654 9.8026 12.932L8.8026 14.2654C8.3626 14.852 7.6426 14.852 7.2026 14.2654L6.2026 12.932C6.09594 12.7854 5.84927 12.6654 5.66927 12.6654Z",
    stroke: "#714FFF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 5.33203H11.3307",
    stroke: "#714FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 8.66797H8.66406",
    stroke: "#714FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1556_106956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.3612ea0d97ded1dfa617a4ef5b760120.svg";
export { ForwardRef as ReactComponent };